<template>
  <div>
    <commBanner :obj="obj" navType="4"></commBanner>
    <titleHead :headTitle="obj.title" :headText="obj.content"></titleHead>
    <div class="data_center_content warp">
      <!--左边-->
      <div class="data_center_item">
        <div class="search_input">
          <input
            type="text"
            v-model="keyword"
            placeholder="请输入你要查询的关键字"
            @keyup.enter="getDataList"
          />
          <button @click="getDataList">
            <img src="../assets/images/search.png" alt="" />
          </button>
        </div>
        <div class="search_keywords">
          <span>关键字:</span>
          <a @click="setKeyword(item)" v-for="(item, index) in keyswordList"
            :key="index"
            :href="item.link"
            target="_blank"
            >{{ item.name }}</a>
        </div>
		<!--分类-->
        <div class="news_item_nav">
          <ul>
            <li
              :class="current == index ? 'active' : ''"
              v-for="(item, index) in categoryList"
              :key="index"
              @click="navChange(index,item)"
              @mouseenter="mouseover(index,item)"
              @mouseleave="mouseLeave(item)"
              v-if="industryList_detection(item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>

        <newsList class="news_item" :list="dataList"></newsList>
        <Pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.curPage"
          :limit.sync="listQuery.limit"
          @pageChange="pageChange"
        ></Pagination>

        <!-- <div class="get_more">
          <span>加载更多</span>
        </div> -->
      </div>
      <!--右边-->
      <div class="data_center_recommend">
        <div class="find_right" v-if="advList.length>0">
          <a :href="'//'+advList[0].url" target="_blank">
            <img :src="advList[0].image" alt="" />
            <span>广告</span>
          </a>
        </div>
        <div class="example_list_right">
          <div class="prod_recommend_head">
            <h3>推荐资料</h3>
            <span @click="getRandomList(4)">换一批</span>
          </div>
          <ul>
            <li
              @click="goToDetail(item)"
              v-for="(item, index) in recommendList"
              :key="index"
            > 
              <div class="pord_box">
                <img :src="item.covers" alt="" />
              </div>
              <div class="example_info">
                <p>{{ item.title }}</p>
                <span>观看人数：{{ item.visitcount}}</span>
              </div>
            </li>
          </ul>
        </div>
        <!-- <prodRecommend :newsRecommendObj="newsRecommendObj"></prodRecommend> -->
        <prodSide class="mt-10" :prodSideObj="prodSideObj" @randomData="randomLessonList"></prodSide>
      </div>
    </div>
  </div>
</template>

<script>
import { getRandomArray,routerGoNewpage } from "../utils/index";
import {getDict} from "@/api/coment"
import { getDataList,getLessonList,getAdv } from "../api/information";
import commBanner from "../common/commBanner";
import titleHead from "../common/titleHead";
import prodSide from "../common/prodSide";
import prodRecommend from "../common/prodRecommend";
import newsList from "../components/newsList";
import Pagination from "../components/Pagination";
export default {
  components: {
    commBanner,
    titleHead,
    prodSide,
    prodRecommend,
    newsList,
    Pagination,
  },
  provide: {
    urlType: "data_detail",
  },
  data() {
    return {
      obj: {
        title: "资料中心",
        roleType:'',
        personalType:4,
      },
      recommendList: [],
      allList: [],
      dataList: [],
      listQuery: {
        curPage: 1,
        limit: 5,
      },
      total: 0,
      keyword: undefined,
      prodSideObj: {
        prodTitle: "推荐课程",
        prodText: "换一批",
        isShow: true,
        prodData: [],
      },
      imgLists: [
        require("../assets/images/bg/bg_4.jpg"),
        require("../assets/images/bg/bg_5.jpg"),
        require("../assets/images/bg/bg_6.jpg"),
      ],
      allLessonList:[],
      advType: 6,
      advList: [],
	    industry_type:'',
	    current: 0,
      currentType:'',
      categoryList:[], //分类
      keyswordList:[]
    };
  },
  created() {
    this.getDataList();
    this.getRecommendDataList();
    this.getRecommenedLesson();
    this.getAdv();
    this.getCailter();
    if(this.$store.state.user.userInfo !=null){
      let type = this.$store.state.user.userInfo.type;
      this.obj.roleType = type;
    }
  },
  computed:{
     dictList(){
       return this.$store.state.industry.list.length > 0 &&
         this.$store.state.industry.list[0].children
     }
  },
  watch:{
    dictList: {
      handler: function(val){
        if(!val[0])return;
        this.currentType = val[0].id;
        this.getDataList();
      },
      immediate: true,
    },
  },
  methods: {
    industryList_detection(id){
      var arr = [15,16,17,18]
      if (arr.indexOf(id) != -1){
        return false
      }else{
        return true
      }
    },
    setKeyword(item) {
      // this.keyword = item.name || item;
    },
    //获取广告
    getAdv() {
      getAdv({
        curPage: 1,
        limit: 10,
        type: this.advType,
      }).then((res) => {
		 if(res.code == 0){
		   this.advList = res.page.list;
		 }
      });
    },
    //获取推荐课程
    getRecommenedLesson(){
     getLessonList({
       recommend: 1,
     }).then(res=>{
		 if(res.code == 0){
			this.allLessonList = res.page.list;
			this.randomLessonList(); 
		 }
     })
    },
    randomLessonList(){
        this.prodSideObj.prodData = this.getRandomLessonList(this.allLessonList,2);
    },
    getRandomLessonList(list,length){
        return  _.compact(getRandomArray(_.cloneDeep(list), length))
    },
    //获取资料中心列表
    getDataList() {
      getDataList({
        ...this.listQuery,
        category: this.currentType,
        keyword: this.keyword
      }).then((res) => {
		if(res.code == 0){
		   this.dataList = res.page.list;
		   this.getMate(this.dataList);
		   this.total = res.page.totalCount;
		}
      });
    },
    //获取推荐资料列表 前端随机取4个
    getRecommendDataList() {
      getDataList({
        recommend: 1,
      }).then((res) => {
		 if(res.code == 0){
			this.allList = res.page.list;
			this.getRandomList(4);
		 }
      });
    },
    getRandomList(length) {
      this.recommendList = _.compact(
        getRandomArray(_.cloneDeep(this.allList), length)
      );
    },
    //分页
    pageChange(item) {
      this.listQuery["curPage"] = item.page;
      this.listQuery["limit"] = item.limit;
      this.getDataList();
    },
    goToDetail(item) {
      routerGoNewpage("/data_detail",{id:item.id})
    },
	//分类
	navChange(index,item){
	  this.current = index;
	  this.currentType = item.id;
	  this.getDataList();
  },
  //移入移出事件
  mouseover(index,data){
    this.$nextTick(()=>{
      this.current = index;
      this.currentType = data.id;
      this.listQuery.curPage =1;
      this.total = 0;
      this.getDataList();
      this.$set(data,'show',true)
    });
    },
  mouseLeave(data){
     this.$set(data,'show',false)
  },
	//行业分类
	getCailter(){
	  let params={ code:this.industry_type};
	  getDict(params).then((res)=>{
		 if(res.code == 0){
			this.categoryList = res.data[0].children;
			this.keyswordList = res.data[1].children;
      for(var i in res.data[8].children){
        this.categoryList.splice(this.categoryList.length - 1,0,res.data[8].children[i])
      }
		 }
	  }).catch((err)=>{})
  },
   getMate(data){
      var metas = document.getElementsByTagName("meta"); 
      metas[0].name ="keyword" 
      metas[0].content= data[0].seokeywords
      metas[1].name ="description" 
      metas[1].content=data[0].seodescription
      document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
      // document.getElementsByTagName("title")[0].innerText= data[0].title +'_智污邦环保服务平台';
    },
  },
};
</script>

<style scoped lang="less">
.page {
  text-align: center;
  margin-top: 40px;
}
.data_center_content {
  display: flex;
  justify-content: space-between;
  .data_center_item {
    width: 72%;
    // margin-right: 30px;
    .search_input {
      display: flex;
      input {
        flex: 7;
        border: 1px solid #65b62b;
        border-right: none;
        padding: 16px;
      }
      button {
        padding: 0 34px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        background: #3bae30;
        img {
          width: 21px;
          height: 21px;
        }
      }
    }
    .search_keywords {
      margin-top: 5px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      span {
        margin-right: 10px;
        cursor: pointer;
        &:first-of-type {
          margin-right: 0;
        }
      }
      a{
        color: #999999 !important;
        padding-right: 15px;
      }
    }
  }
  .data_center_recommend {
    // flex: 3;
    width: 25%;
  }
}
.news_item {
  margin-top: 20px;
}
.example_list_right {
  // flex: 3;
  // max-width: 293px;
  border-top: 3px solid rgba(153, 207, 42, 1);
  background: #f8f8f8;
  padding: 18px 15px;
  margin-bottom: 20px;
  .prod_recommend_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #9a9a9a;
      &::before {
        display: inline-block;
        content: "";
        width: 17px;
        height: 17px;
        background: url("../assets/images/break.png") no-repeat center/100%;
        vertical-align: top;
        margin-right: 3px;
      }
    }
  }
  ul {
    li {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      padding-top: 10px;
      // &:last-of-type {
      //   margin-bottom: 0;
      // }
       .pord_box{
          width: 204px;
          height: 113px;
          overflow: hidden;
        img {
        width: 100%;
        height: 100%;
        object-fit: fill;
        display: block;
        }
      }
      
      .example_info {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-left: 12px;
        overflow: hidden;
        p {
          max-width: 176px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        span {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
}

.find_right {
  position: relative;
  margin-bottom: 10px;
}
.find_right img {
  width: 100%;
  height: 184px;
}
.find_right span {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.get_more {
  margin: 20px 0 0;
  text-align: center;
  span {
    position: relative;
    display: inline-block;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    &::before {
      position: absolute;
      right: 0;
      top: 12px;
      display: inline-block;
      width: 15px;
      height: 15px;
      content: "";
      background: url("../assets/images/more.png") no-repeat center/100%;
    }
  }
}

.news_item_nav {
  margin-top: 20px;
  line-height: 62px;
  background: url("../assets/images/bg_8.jpg") no-repeat center/cover;
  ul {
    display: flex;
    padding: 0 30px;
    li {
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 24px;
      &:last-of-type {
        margin-right: 0;
      }
    }
    .active {
      position: relative;
      &::after {
        position: absolute;
        bottom: 10px;
        left: 0;
        display: inline-block;
        content: "";
        width: 100%;
        height: 2px;
        background: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/data_center.vue